const S = { fill: "none", stroke: "currentColor", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" };

const Svg = ({ size, vb = "0 0 48 48", className = "", children, ratio = 1 }) => (
  <svg viewBox={vb} width={size} height={size * ratio} className={className} aria-hidden="true"><g {...S}>{children}</g></svg>
);

export const Crown = ({ size = 48, className = "" }) => (
  <Svg size={size} vb="0 0 64 44" ratio={44 / 64} className={className}>
    <path d="M7 37L9 11l13 12L32 5l10 18 13-12 2 26z" /><path d="M8 37h48" /><circle cx="9" cy="8" r="1.5" /><circle cx="32" cy="2.5" r="1.5" /><circle cx="55" cy="8" r="1.5" />
  </Svg>
);

export const Globe = ({ size = 40, className = "" }) => (
  <Svg size={size} className={className}><circle cx="24" cy="24" r="19" /><ellipse cx="24" cy="24" rx="8" ry="19" /><path d="M6 18c12 3 24 3 36 0M6 30c12-3 24-3 36 0" /></Svg>
);

export const Sparkle = ({ size = 40, className = "" }) => (
  <Svg size={size} className={className}><path d="M22 5c1.5 11 4.5 14.5 16 16-11.5 1.5-14.5 5-16 16-1.5-11-4.5-14.5-16-16 11.5-1.5 14.5-5 16-16z" /><path d="M40 6v8M36 10h8" /></Svg>
);

export const Smiley = ({ size = 40, className = "" }) => (
  <Svg size={size} className={className}><circle cx="24" cy="24" r="19" /><path d="M17 19v2M31 19v2" strokeWidth="4" /><path d="M14 28c5 8 15 8 20 0" /></Svg>
);

export const Peace = ({ size = 40, className = "" }) => (
  <Svg size={size} className={className}><circle cx="24" cy="24" r="19" /><path d="M24 5v38M24 25L11 38M24 25l13 13" /></Svg>
);

export const Barcode = ({ size = 56, className = "" }) => (
  <Svg size={size} vb="0 0 64 40" ratio={40 / 64} className={className}>
    {[[4, 3], [10, 1.5], [15, 4], [22, 1.5], [27, 3], [33, 1.5], [38, 4], [45, 1.5], [50, 3], [56, 1.5], [60, 2.5]].map(([x, w]) => <path key={x} d={`M${x} 4v26`} strokeWidth={w} strokeLinecap="butt" />)}
    <path d="M4 36h56" strokeWidth="1.2" strokeDasharray="2 3" />
  </Svg>
);

export const SusCrew = ({ className = "" }) => (
  <span className={`inline-flex flex-col border-[1.5px] border-current px-2 pb-1 pt-1.5 font-display uppercase leading-[0.85] ${className}`} aria-label="Sus Crew trademark">
    <span>Sus</span><span>Crew<sup className="ml-0.5 font-mono text-[0.4em]">™</sup></span>
  </span>
);

export const Arrow = ({ className = "" }) => (
  <svg viewBox="0 0 90 60" className={className} fill="none" aria-hidden="true">
    <g {...S} strokeWidth="2"><path d="M4 8c22 2 52 12 70 42" /><path d="M60 44l14 8 3-16" /></g>
  </svg>
);

export const Marker = ({ children, className = "", rotate = -4 }) => (
  <span className={`font-hand inline-block ${className}`} style={{ transform: `rotate(${rotate}deg)` }}>{children}</span>
);

export const Divider = ({ icon: Icon = Smiley, className = "" }) => (
  <div className={`mx-auto flex max-w-[1440px] items-center gap-6 px-5 sm:px-10 ${className}`} aria-hidden="true">
    <span className="h-px flex-1 bg-ink/10" /><Icon size={34} /><span className="h-px flex-1 bg-ink/10" />
  </div>
);
